jQuery(document).ready(function ($) {
  //############################################//
	//###*****   Component - Site Navigation    
	//###*****   Use with styles /styles/components/site-nav.scss  
	//############################################//  
  var $siteNav = $('.c-site-nav')
  var $siteNavToggle = $('.js-site-nav--toggle')
  var $siteNavItem = $('.c-site-nav__item')

  //In menu Dropdown menu
  if ($(window).width() < 992) {
    // Main dropdown
    $('.c-site-nav__dropdown')
      .parent()
      .find('> .c-site-nav__dropdown-submenu-link')
      .on('click', function(e) {
        e.preventDefault()
        var submenu = $(this)
          .parent()
          .children('.c-site-nav__dropdown')
        $(this)
          .parent()
          .siblings()
          .removeClass('is-open')
          .children('.c-site-nav__dropdown')
          .slideUp(200)

        if ($(submenu).is(':hidden')) {
          $(submenu).slideDown(200)
          $(submenu)
            .parent()
            .addClass('is-open')
        } else {
          $(submenu).slideUp(200)
          $(submenu)
            .parent()
            .removeClass('is-open')
        }
      })
  }

    //Add is-active to first item in dropdown menu
    $siteNavItem.hover(
        function(e) {
        var $this = $(this)

        var itemDivWidth = $this.offset().left
        console.log(itemDivWidth)
        //matchMedia
        const mq = window.matchMedia("(min-width: 992px)");
        if (mq.matches) {
          $this.find('.c-site-nav__dropdown--wide-list').css('margin-left', itemDivWidth);
        }
        
        $this.addClass('is-active')
        //var $thisDropdown = $this.find('.c-site-nav__dropdown')
        },
        function() {
        $(this).removeClass('is-active')
        }
    )



    const mq = window.matchMedia("(min-width: 992px)");
    if (mq.matches) {


      function getClass(element, startsWith) {

        var result = undefined;
        $(element.attr('class').split(' ')).each(function() {
          if (this.indexOf(startsWith) > -1) result = this;
        });
        return result;
      }   

      //Add matching classes to Parent and submenu container
      $('.c-site-nav__dropdown .c-site-nav__item-dropdown').each(function(i){
          $(this).find('.c-site-nav__link-dropdown').attr('id', 'menu--' + i);
          $(this).find('.level2').addClass('menu--' + i);
          $(this).find('.c-site-nav__link-container').addClass('menu--' + i);
          //$(this).find('.menulbl').prependTo('.c-site-nav ul.menu--' + i);
      }); 

      //Move sub sub links
      $('.c-site-nav__dropdown .c-site-nav__item-dropdown .level2').each(function(){
        $(this).closest('.c-site-nav__dropdown').find('.c-site-nav__dropdown-sub-container').append($(this));
      }); 


      //Clone sub link containers into logo container
      $('.c-site-nav__dropdown--wide .c-site-nav__item-dropdown .c-site-nav__link-container').each(function(){  
        $(this).closest('.c-site-nav__dropdown').find('.c-site-nav__dropdown-logo-container').append($(this).clone());
        //$(this).closest('.c-site-nav__dropdown').find('.c-site-nav__dropdown-logo-container').append($('.c-site-nav__link-icon'));
      })

      // Hide all link container data
      $('.c-site-nav__dropdown-logo-container .c-site-nav__link-container').hide().removeClass('is-active');

      //Sub link hovers
      $('.c-site-nav__link-dropdown').each(function(){
        $(this).hover( function() {
            console.log('hovered');

            // Hide all subs
            $('.c-site-nav__dropdown-sub-container .level2').hide().removeClass('is-active');

            // Hide all link container data
            $('.c-site-nav__dropdown-logo-container .c-site-nav__link-container').hide().removeClass('is-active');

            // Then show the ones that match this `id`
            $(this).parent().addClass('is-active');
            $("." + this.id).show().addClass('is-active');

            $(this).closest('.c-site-nav__dropdown').find('.c-site-nav__dropdown-logo-container .c-site-nav__link-container.' + this.id).show().addClass('is-active');
            // $('.c-site-nav__link-dropdown')
            
        }, function() {
              $(this).parent().removeClass('is-active');
              //$(this).closest('.c-site-nav__dropdown').find('.c-site-nav__dropdown-logo-container .c-site-nav__link-container.' + this.id).hide().removeClass('is-active');
            //console.log('hovered out');
        });
      });



    } 




})